import { mapToImpactResearchTopic } from "~/mappers";
import { useImpactTrackingV1Service } from "~/composables/useImpactTrackingV1Service";
import { useImpactTrackingV2Service } from "~/composables/useImpactTrackingV2Service";
import {
  FrontiersImpactActionNames,
  FrontiersImpactActionTypes
} from "~/types/global/enums";

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) return;
  if (!to.name?.toString().includes("research-topics-rtId-rtSlug")) return;

  const event = useRequestEvent();

  if (event) {
    const {
      currentResearchTopic: { id, journals }
    } = useMain();
    const { loggedUser } = useAuthStore();
    const { postTracking } = useImpactTrackingV1Service(event.node.req);
    const { sendTracking } = useImpactTrackingV2Service(event.node.req);

    const impactRt = mapToImpactResearchTopic(id, journals);

    sendTracking(
      FrontiersImpactActionNames.ResearchTopicView,
      impactRt,
      loggedUser?.id
    );

    postTracking(
      FrontiersImpactActionTypes.ResearchTopicView,
      impactRt,
      loggedUser?.id
    );
  }
});
